import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import uuid from 'uuid/v4';

import Title from '../title';
import validate from './validate';
import FormField from '../form-field';
import '../../css/cancel-purchase.css';

class CancelPurchase extends Component {
  renderInitalMessage() {
    const { purchaseName, contributorsCount } = this.props;

    if (contributorsCount > 0) {
      return (
        <p>
          <FormattedMessage
            id="cancelPurchase.initialMessage.withContributors"
            defaultMessage="If you cancel this group, {contributorsCount}
            will miss out on {purchaseName} with you, and:"
            values={{
              contributorsCount,
              purchaseName: <strong>{purchaseName}</strong>,
            }}
          />
        </p>
      );
    }

    return (
      <p>
        <FormattedMessage
          id="cancelPurchase.initialMessage.noContributors"
          defaultMessage="If you cancel this group, everyone will lose {purchaseName}, and:"
          values={{ purchaseName: <strong>{purchaseName}</strong> }}
        />
      </p>
    );
  }

  renderPurchaseToCancelInfo() {
    return (
      <div className="mt-1">
        {this.renderInitalMessage()}
        {renderDisadvantages()}
        <p className="cool-grey">
          <FormattedMessage
            id="cancelPurchase.conctactSupport"
            defaultMessage="Consider contacting {email} first to solve any issue."
            values={{
              email: (
                <a href="mailto:info@keytravel.com" target="_blank" rel="noopener noreferrer">
                  info@keytravel.com
                </a>
              )
            }}
          />
        </p>
      </div>
    );
  }

  renderButtons() {
    const { submitting } = this.props;

    return (
      <div className="row pt-4">
        <div className="offset-3 col-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.props.onKeepGroup}
          >
            <FormattedMessage
              id="cancelPurchase.buttons.keep"
              defaultMessage="Keep my group"
            />
          </button>
        </div>
        <div className="col-5 small-print">
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            <FormattedMessage
              id="cancelPurchase.buttons.confirm"
              defaultMessage="Confirm cancellation"
            />
          </button><br />
          <span className="coral-error">
            <FormattedMessage
              id="cancelPurchase.button.warning"
              defaultMessage="This action CANNOT be undone"
            />
          </span>
        </div>
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="cancel-purchase">
        <div className="modal-title modal-section blue full">
          <h1>
            <FormattedMessage
              id="cancelPurchase.title"
              defaultMessage="Cancel group"
            />
          </h1>
        </div>
        {this.renderPurchaseToCancelInfo()}
        <form onSubmit={handleSubmit(this.props.onSubmit)} className="my-3">
          <div className="modal-section divider">
            <Title
              text={
                <FormattedMessage
                  id="cancelPurchase.personalMessage"
                  defaultMessage="Personal message"
                />
              }
              divider
            />
            <span className="cool-grey">
              <FormattedMessage
                id="cancelPurchase.personalMessage.subtext"
                defaultMessage="Let your contributors know why you canceled."
              />
            </span>
            <Field
              name="reason"
              type="textarea"
              component={FormField}
            />
          </div>
          {this.renderButtons()}
        </form>
      </div>
    );
  }
}

const disadvantages = [
  <FormattedMessage
    id="cancelPurchase.disadvantages.first"
    defaultMessage="- No contributors will be charged"
  />,
  <FormattedMessage
    id="cancelPurchase.disadvantages.second"
    defaultMessage="- We will notify contributors about the cancellation"
  />,
  <FormattedMessage
    id="cancelPurchase.disadvantages.third"
    defaultMessage="- You will lose all progress"
  />,
  <FormattedMessage
    id="cancelPurchase.disadvantages.fourth"
    defaultMessage="- It will be impossible to recover this purchase"
  />,
  <FormattedMessage
    id="cancelPurchase.disadvantages.fifth"
    defaultMessage="- We will miss you 😢"
  />,
];

const renderDisadvantages = () => (
  <ul className="unstyled my-3">
    {disadvantages.map(renderDisadvatage)}
  </ul>
);

const renderDisadvatage = text => <li className="cool-grey" key={uuid()}>{text}</li>;

export default reduxForm({ form: 'cancelPurchase', validate })(CancelPurchase);



// WEBPACK FOOTER //
// ./src/desktop/components/cancel-purchase/index.js